module.exports = __webpack_public_path__ + "static/studio-bea5d40cffbdcec5bd1f8914b53d6ace.png";